import { render, staticRenderFns } from "./CategoryUpdate.vue?vue&type=template&id=cba08c6a&"
import script from "./CategoryUpdate.vue?vue&type=script&lang=ts&"
export * from "./CategoryUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports